// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","logo":"Header_logo__shVBB","rightSideContainer":"Header_rightSideContainer__ckVf1","content":"Header_content__8sQm-"};